const messages = {
  title: "Informacije o izdelku in odobritve",
  description:
    "Dobrodošli v sekcijo brošur in cenikov o izdelkih Bridgestone in Firestone. Tu lahko najdete aktualne brošure in cenike za vse izdelkovne področja in Pricat datoteke za vaše upravljanje zalog.",
};
export default {
  messages,
};
